import React from 'react';
import '../styles/LogoTicker.css';

const LogoTicker = () => {
  const brands = [
    { name: 'Honda', svgUrl: 'https://upload.wikimedia.org/wikipedia/commons/0/09/Honda-logo.svg' },
    { name: 'Walmart', svgUrl: 'https://upload.wikimedia.org/wikipedia/commons/b/b1/Walmart_logo_%282008%29.svg' },
    { name: 'Nestle Purina', svgUrl: 'https://upload.wikimedia.org/wikipedia/commons/2/2c/Nestl%C3%A9_Purina_PetCare_logo.svg' },
    { name: 'Kelvin.ai', svgUrl: null, iconUrl: 'https://www.google.com/s2/favicons?domain=kelvin.ai&sz=64' },
    { name: 'Acura', svgUrl: 'https://upload.wikimedia.org/wikipedia/commons/a/af/Acura_logo.svg' }
  ];

  return (
    <div className="logo-ticker-container">
      <div className="container">
        <div className="logo-ticker-box">
          <div className="logo-ticker-content">
        {brands.map((brand, index) => (
          <div key={`logo-${index}`} className="logo-ticker-item">
            {brand.svgUrl ? (
              <img 
                src={brand.svgUrl} 
                alt={`${brand.name} logo`} 
                className="logo-ticker-img" 
              />
            ) : brand.iconUrl ? (
              <span className="logo-text-placeholder logo-text-with-icon">
                <img
                  src={brand.iconUrl}
                  alt={`${brand.name} icon`}
                  className="logo-ticker-favicon"
                />
                {brand.name}
              </span>
            ) : (
              <span className="logo-text-placeholder">{brand.name}</span>
            )}
          </div>
        ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default LogoTicker;
